import { HeaderDashboard } from '@/components/shared/header-dashboard';
import { BookingDetail } from '@/features/consumer/booking-detail';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';

const bookingDetailSearchSchema = z.object({
  ref: z
    .enum(['dashboard', 'bookings', 'history'])
    .optional()
    .default('bookings'),
  section: z.string().optional(),
  showReviewModal: z.string().optional(),
  view: z.string().optional(),
});

export const Route = createFileRoute('/(consumer)/_authenticated/bookings/$id')(
  {
    component: BookingDetailPage,
    validateSearch: bookingDetailSearchSchema,
  }
);

function BookingDetailPage() {
  const navigate = useNavigate();
  const { ref } = Route.useSearch();
  const { id: bookingId } = Route.useParams();

  const getBackPath = () => {
    switch (ref) {
      case 'dashboard':
        return '/dashboard';
      case 'history':
        return '/bookings/history';
      case 'bookings':
      default:
        return '/bookings';
    }
  };

  return (
    <div>
      <HeaderDashboard>
        <HeaderDashboard.BackButton
          onClick={() => navigate({ to: getBackPath() })}
        />
        <HeaderDashboard.Title>
          ID: #{bookingId.length > 8 ? bookingId.slice(0, 8) : bookingId}
        </HeaderDashboard.Title>
      </HeaderDashboard>
      <div className="flex flex-col gap-4">
        <BookingDetail />
      </div>
    </div>
  );
}
